module.exports = __webpack_public_path__ + "img/icon_certificate.e50b6dd.svg";